import React, { useEffect, useState } from "react";
import { api } from "../../app/Api/ApiSlice";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import moment from "moment";

const StoreOrders = () => {
    const [userOrders, setUserOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const { name } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const getOrders = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`/stores/${name}/orders`);
                setUserOrders(response.data || []);
            } catch (error) {
                toast.error(error.response?.data?.message || "Error fetching orders");
            } finally {
                setIsLoading(false);
            }
        };

        getOrders();
    }, [name]);

    return (
        <div className="store-user-carts-list">
            <h5>My Orders in {name}</h5>

            {isLoading && <Loader />}

            {!isLoading && userOrders.length === 0 && (
                <p className="not-found-msg">
                    You have not created any order in this store
                </p>
            )}

            {!isLoading && userOrders.length > 0 && (
                <table>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Order No</th>
                            <th>Cart Name</th>
                            <th>Acknowledged</th>
                            <th>Invoiced</th>
                            <th>Items</th>
                            <th>Total Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {userOrders.map(order => (
                            <tr
                                key={order._id}
                                onClick={() => navigate(`/b/${name}/orders/${order._id}`,{state:order})}
                                style={{ cursor: "pointer" }}
                            >
                                <td>{moment(order.createdAt).format("DD/MM/YYYY")}</td>
                                <td>{order.orderNo}</td>
                                <td>{order.cart?.name}</td>
                                <td>{order.acknowledged?"yes":"No"}</td>
                                <td>{order.invoiced?"Yes":"No"}</td>
                                <td>{order.items.length}</td>
                                <td>{order.totalAmount}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default StoreOrders;
